<template>
    <div>
        <div :class="view_class_view.div_container">
            <div v-if="show_container.phone">
                <label :class="view_class_view.input_label" for="input_phone_contact">Teléfono:</label>
                <input type="text" id="input_phone_contact"
                    v-maska="view_class_view.div_conteiner_phone.input_mask" inputmode="tel"
                    v-bind:class="{[ view_class_view.input_class.default + view_class_view.input_class.no_valid ]: _contacModelValidation$.phone.$error,
                    [view_class_view.input_class.default + view_class_view.input_class.valid]:!_contacModelValidation$.phone.$invalid,
                    [view_class_view.input_class.default ]: _contacModelValidation$.phone.$invalid && !_contacModelValidation$.phone.$error  }"
                    v-model="contacModel.phone"
                    @blur="_contacModelValidation$.phone.$validate">

                    <div :class="view_class_view.div_container_error.container" v-for="(error,index) of _contacModelValidation$.phone.$errors" :key="index">
                        <div :class="view_class_view.div_container_error.text_error">{{ error.$message }}</div>
                    </div>  
            </div>

            <div v-if="show_container.cellPhone">
                <label :class="view_class_view.input_label" for="input_cellphone_contact">Celular:</label>
                <input type="text" id="input_cellphone_contact"
                    :disabled="verification_required && isValidCode"
                    v-maska="view_class_view.div_conteiner_cellPhone.input_mask" inputmode="tel"
                    v-bind:class="{[ view_class_view.input_class.default + view_class_view.input_class.no_valid ]: _contacModelValidation$.cellPhone.$error,
                    [view_class_view.input_class.default + view_class_view.input_class.valid]:!_contacModelValidation$.cellPhone.$invalid,
                    [view_class_view.input_class.default ]: _contacModelValidation$.cellPhone.$invalid && !_contacModelValidation$.cellPhone.$error  }"
                    v-model="contacModel.cellPhone"
                    @blur="_contacModelValidation$.cellPhone.$validate">

                    <div :class="view_class_view.div_container_error.container" v-for="(error,index) of _contacModelValidation$.cellPhone.$errors" :key="index">
                        <div :class="view_class_view.div_container_error.text_error">{{ error.$message }}</div>
                    </div>  

                    <div class="w-full flex justify-right items-right" v-if="contacModel.cellPhone!='' && !_contacModelValidation$.cellPhone.$invalid && verification_required">
                        <button v-if="!isValidCode" :class="view_class_view.input_confirm_class" id="button_verification_cellphone" style="background-color: #FFC001 !important; color: rgb(255, 255, 255) !important; border-color: #FFC001; border-width: thin;" @click="sendSMSwithCode()"> {{ isCodeSent? 'Reenviar código': 'Verificar celular'}} </button>
                        <span v-if="isValidCode" class="font-bold text-sm text-green-600"> Celular Validado </span>
                    </div>
            </div>
            <div v-if="show_container.email">
                <label :class="view_class_view.input_label" for="input_email_contact">Correo Electrónico:</label>
                <input type="text" id="input_email_contact"  
                    v-bind:class="{[ view_class_view.input_class.default + view_class_view.input_class.no_valid ]: _contacModelValidation$.email.$error,
                    [view_class_view.input_class.default + view_class_view.input_class.valid]:!_contacModelValidation$.email.$invalid,
                    [view_class_view.input_class.default ]: _contacModelValidation$.email.$invalid && !_contacModelValidation$.email.$error  }"
                    v-model="contacModel.email"
                    @blur="_contacModelValidation$.email.$validate">

                    <div :class="view_class_view.div_container_error.container" v-for="(error,index) of _contacModelValidation$.email.$errors" :key="index">
                        <div :class="view_class_view.div_container_error.text_error">{{ error.$message }}</div>
                    </div>  
            </div>
        </div>
    </div>
</template>

<script>
import { ref, toRef } from 'vue';
import axios from 'axios';
import useVuelidate from '@vuelidate/core';
import Swal from 'sweetalert2';
import CryptoJS from 'crypto-js';

export default({
    name:"ContactComponent",
    props:{
        business_name_params: {
            type: String,
            default(){
                return "";
            }
        },
        business_name: {
            type: String,
            default(){
                return "";
            }
        },
        verification_required: {
            type: Boolean,
            default(){
                return false;
            }
        }, 
        api_url: {
            type: String, 
            default(){
                return "";
            }
        },
        view_class_view:{
            type: Object,
            default(){
                return {
                    input_label:"",
                    input_class:{
                        valid: "",
                        no_valid: "",
                        default: ""
                    },
                    input_confirm_class: "",
                    div_container_error:{
                        container: "",
                        text_error: "",
                    },
                    div_conteiner_phone:{
                        input_mask: ""
                    },
                    div_conteiner_cellPhone:{
                        input_mask: ""
                    },
                    div_container: ""
                }
            }
        },
        validations:{},
        show_container:{
            type: Object,
            default(){
                return {
                    phone: true,
                    cellPhone: true,
                    email: true
                }
            }
        }
    },
    setup(props) {
        let verificationAttempts = ref(0);
        let codeNumber = ref('');
        let contacModel = ref( { phone:"", cellPhone:"", email:""} );
        let _contacModelValidation$ = useVuelidate(props.validations,contacModel);
        let apiUrl = toRef(props, 'api_url');
        let businessName = toRef(props, 'business_name');
        let businessNameParams = toRef(props, 'business_name_params');
        let isCodeSent = ref(false);
        let isValidCode = ref(false);

        function execute_validation() {
          this._contacModelValidation$.$validate();
          if(this._contacModelValidation$.$error){
            return false;
          }
          return _contacModelValidation$.value;
        }

        function validateCellphone() {
            Swal.fire({
                title: 'Favor de introducir el código de verificación enviado a su celular',
                input: 'text',
                inputLabel: 'Código:',
                inputAttributes: {
                    maxlength: 5,
                    autocapitalize: 'off',
                },
                showCancelButton: true,
                confirmButtonText: 'Verificar',
                cancelButtonText: 'Cancelar',
                showLoaderOnConfirm: true,
                reverseButtons: true,
                preConfirm: (code) => {
                    if(code.length < 5){
                        verificationAttempts.value = verificationAttempts.value + 1;
                        Swal.showValidationMessage(`El código debe tener 5 dígitos`)
                        return false;
                    }
                    
                    isValidCode.value = (decryptMessage(codeNumber.value) == code)? true: false;
                    if(!isValidCode.value) Swal.showValidationMessage(`El código es incorrecto`);

                    if(isValidCode.value) {
                        codeNumber.value = decryptMessage(codeNumber.value);
                    }

                    return isValidCode.value;
                },
                allowOutsideClick: () => !Swal.isLoading()
            }).then((result) => {
                if (result.isConfirmed) {
                    verificationAttempts.value = 0;
                    Swal.fire({
                        title: "Aviso",
                        customClass: {
                            container: 'my-swal'
                        },
                        text: "Celular verificado correctamente",
                        confirmButtonColor: '#FEB72B',
                        icon: "success",
                    });
                }
            })
            
        }

        async function sendSMSwithCode(){
            
            await axios
            .post(apiUrl.value + `/${businessName.value}/cellphone_number_verification/send_verification_code`, {
                business_name: businessNameParams.value,
                token_auth: sessionStorage.getItem("login"),
                phone_number: removeMask(contacModel.value.cellPhone)
            })
            .then((response) => {
                isValidCode.value = false;
                isCodeSent.value = true;
                validateCellphone();
                codeNumber.value = response.data.response.code;
            })
            .catch((error) => {
                isCodeSent.value = false;
                console.error("Error al enviar el SMS: ", error);
                Swal.fire({
                    title: "Aviso",
                    customClass: {
                        container: 'my-swal'
                    },
                    text: "Error al enviar el SMS",
                    icon: "error",
                    confirmButtonColor: '#FEB72B',
                });
            })
        }

        function removeMask(phone) {
            if (phone.includes("(")) {
                phone = phone.replace("(", "");
            }
            if (phone.includes(")")) {
                phone = phone.replace(")", "");
            }
            if (phone.includes("-")) {
                phone = phone.replace("-", "");
            }
            if (phone.includes(" ")) {
                phone = phone.replace(" ", "");
            }
            return phone;
        }

        function decryptMessage(ciphertext) {

            // Clave de cifrado
            const key = CryptoJS.enc.Utf8.parse("d721ead1f5fdcds2"); // La clave debe tener 16, 24 o 32 bytes

            // Decodificar el texto cifrado desde base64
            ciphertext = CryptoJS.enc.Base64.parse(ciphertext);

            // Configurar los parámetros de descifrado
            const decryptParams = {
                ciphertext,
                key,
                padding: CryptoJS.pad.Pkcs7, // ECB no utiliza IV
                mode: CryptoJS.mode.ECB, // Modo de operación ECB
            };

            // Realizar el descifrado
            const decryptedBytes = CryptoJS.AES.decrypt(decryptParams, key, {
                padding: CryptoJS.pad.Pkcs7,
                mode: CryptoJS.mode.ECB,
            });

            // Convertir los bytes descifrados a texto
            const decryptedText = decryptedBytes.toString(CryptoJS.enc.Utf8);
            
            return decryptedText;
        }
        
        return {
            contacModel,
            _contacModelValidation$,
            execute_validation,
            sendSMSwithCode,
            decryptMessage,
            isValidCode,
            codeNumber,
            isCodeSent
        }
    }
});
</script>